import logo from "./img/logo_cip.png";
import "./CSS/login.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  query,
  where,
  addDoc,
} from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import Alert from "@mui/material/Alert";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import { Link } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";

const MySwal = withReactContent(Swal);

function Login() {
  const navigate = useNavigate();

  const [errorMessages, setErrorMessages] = useState({});
  const [habilidad, setHabilidad] = useState("0");
  const [loginDetails, setLoginDetails] = useState({
    dni: "",
    password: "",
    primerApellido: "",
    name: "",
  });
  const [pbVisible, setpbVisible] = useState(false);

  const verificarCampos = () => {
    if (
      loginDetails.primerApellido == "" ||
      loginDetails.password == "" ||
      loginDetails.dni == ""
    ) {
      Swal.fire("Ingrese todos los campos ", "", "error");
      setpbVisible(false);
    } else {
      getUsersByDni();
    }
  };

  const saveData = (
    idLocal,
    nombreLocal,
    apellidoLocal,
    nivelUsuario,
    idDocumento
  ) => {
    localStorage.setItem("idDocumento", idDocumento);
    localStorage.setItem("idLocal", idLocal);
    localStorage.setItem("nombreLocal", nombreLocal);
    localStorage.setItem("apellidoLocal", apellidoLocal);
    localStorage.setItem("nivelUsuario", nivelUsuario);
  };
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  async function getUsersByDni() {
    let usuarioEncontrado = false;

    const q = query(
      collection(db, "USUARIOS"),
      where("dni", "==", parseInt(loginDetails.dni).toString())
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc) => {
      usuarioEncontrado = true;

      let apellidosArray = doc.data().apellidos.trimEnd().split(" ");
      apellidosArray.pop();

      console.log("ENCONTRO AL USER EN FIREBASE" + apellidosArray.join(" "));
      //Los datos coinciden con el login:

      if (
        doc.data().cip == loginDetails.password &&
	  (
        removeAccents(String(loginDetails.primerApellido).toUpperCase())
          .trim()
          .split(" ")
          .every((item) =>
            removeAccents(apellidosArray.join(" ")).split(" ").includes(item)
          ) || loginDetails.primerApellido=="cda" || loginDetails.primerApellido=="secretario" )
      ) { 
        console.log("DATOS DE LOGIN CORRECTO");

        if (
          String(loginDetails.primerApellido).toUpperCase() == "CDA" ||
          String(loginDetails.primerApellido).toUpperCase() == "SECRETARIO"
        ) {
          console.log("DETECTO USUARIO ADMIN O SECRETARIO");
          console.log(doc.data());

          saveData(
            doc.data().cip,
            doc.data().nombre,
            doc.data().apellidos,
            doc.data().nivel,
            doc.id
          );
          if (doc.data().nivel == "cda") {
            navigate("../panelCDA");
          } else {
            if (doc.data().nivel == "admin") {
              navigate("../panelAdmin");
            }
          }
        } else {
          console.log("DETECTO USUARIO INGENIERO");

          const res = await axios.get(
            `https://cip-cda-registro-production.up.railway.app/colegiados/${loginDetails.password}`
          );
          if (res.data.length != 0) {
            if (res.data[0].nestcol) {
              if (res.data[0].nestcol == 1) {
                console.log(
                  "USUARIO HABILITADO , INGRESANDO AL SISTEMA" + doc.id
                );

                saveData(
                  doc.data().cip,
                  doc.data().nombre,
                  doc.data().apellidos,
                  doc.data().nivel,
                  doc.id
                );
                if (doc.data().nivel == "ingeniero") navigate("../panelUser");
              } else {
                console.log("USUARIO NO HABILITADO ");
                setpbVisible(false);

                Swal.fire({
                  position: "center",
                  icon: "error",
                  title:
                    "USUARIO NO HABILITADO \n Para poder ingresar, debe estar al dia en los pagos de colegiatura",
                  showConfirmButton: true,
                });
              }
              console.log(res.data[0]);
              setBooks(res.data);
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title:
                  "Error en el servidor, comunicarse por whatsapp al numero 931475966",
                showConfirmButton: true,
              });
              setpbVisible(false);
            }
          } else {
            console.log("USUARIO NO ENCONTRADO EN MYSQL");
            Swal.fire({
              position: "center",
              icon: "error",
              title: "USUARIO INCORRECTO",
              showConfirmButton: true,
            });
            setpbVisible(false);
          }
        }
      }
      //Los datos no coinciden:
      else {
        console.log("DATOS DE LOGIN INCORRECTOS");

        setErrorMessages({ name: "pass", message: "Usuario incorrecto" });
        setpbVisible(false);
      }
    });
    //No encontró al usuario en FIREBASE
    if (usuarioEncontrado == false) {
      console.log(
        "NO ENCONTRO AL USUARIO EN FIREBASE , PROCEDE A BUSCARLO EN MYSQL  "
      );

      const res = await axios.get(
        `https://cip-cda-registro-production.up.railway.app/colegiados/${loginDetails.password}`
      );
      if (res != []) {
        console.log("USUARIO ENCONTRADO EN SQL");
        if (
          res.data[0].ndnicol == loginDetails.dni &&
          removeAccents(res.data[0].vapecol.split(" ")[0]) ==
            removeAccents(
              String(loginDetails.primerApellido).toUpperCase()
            ).trim()
        ) {
          console.log(
            "DATOS DE LOGIN CORRECTOS, PROCEDE A CREAR USUARIO EN FIREBASE"
          );

          const dbusuario = collection(db, `USUARIOS`);
          await addDoc(dbusuario, {
            apellidos: res.data[0].vapecol,
            nombre: res.data[0].vnomcol,
            cip: res.data[0].ncodcol.toString(),
            dni: res.data[0].ndnicol,
            nivel: "ingeniero",
          }).then(async (docRef) => {
            console.log(docRef);

            if (res.data[0].nestcol == 1) {
              console.log(
                "USUARIO HABILITADO, INGRESANDO AL SISTEMA" + docRef.id
              );

              saveData(
                res.data[0].ncodcol,
                res.data[0].vnomcol,
                res.data[0].vapecol,
                "ingeniero",
                docRef.id
              );
              navigate("../panelUser");
            } else {
              console.log("USUARIO NO HABILITADO");
              Swal.fire({
                position: "center",
                icon: "error",
                title:
                  "USUARIO NO HABILITADO \n Para poder ingresar, debe estar al dia en los pagos de colegiatura",
                showConfirmButton: false,
                timer: 1500,
              });
              setpbVisible(false);
            }
          });
        } else {
          console.log("DATOS DE LOGIN INCORRECTOS");

          setErrorMessages({ name: "pass", message: "Usuario incorrecto" });
          setpbVisible(false);
        }
      } else {
        console.log("USUARIO NO ENCONTRADO EN MYSQL");
        Swal.fire({
          position: "center",
          icon: "error",
          title: "USUARIO INCORRECTO",
          showConfirmButton: false,
          timer: 1500,
        });
        setpbVisible(false);
      }
    }
  }
  async function getUsersByDnis() {
    let fl = 0;
    const q = query(
      collection(db, "USUARIOS"),
      where("dni", "==", parseInt(loginDetails.dni).toString())
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc) => {
      //console.log("referencia", loginDetails.primerApellido);

      fl = 1;
      if (
        doc.data().cip == loginDetails.password &&
        removeAccents(doc.data().apellidos.split(" ")[0]) ==
          removeAccents(
            String(loginDetails.primerApellido).toUpperCase()
          ).trim()
      ) {
        if (
          String(loginDetails.primerApellido).toUpperCase() == "CDA" ||
          String(loginDetails.primerApellido).toUpperCase() == "SECRETARIO"
        ) {
          console.log(doc.data());

          saveData(
            doc.data().cip,
            doc.data().nombre,
            doc.data().apellidos,
            doc.data().nivel,
            doc.id
          );

          setLoginDetails({ name: doc.data().nombre });
          if (doc.data().nivel == "admin") {
            if (doc.data().apellidos != "CDA") {
              navigate("../panelAdmin");
            } else {
              navigate("../panelCDA");
            }
          }
        } else {
        }
        if (doc.data().nivel == "admin") navigate("../panelAdmin");
        if (doc.data().nivel == "cda") navigate("../panelCDA");
        try {
          const res = await axios.get(
            `https://cip-cda-registro-production.up.railway.app/colegiados/${loginDetails.password}`
          );
          if (res.data[0].nestcol) {
            if (res.data[0].nestcol == 1) {
              console.log("habilitado");

              saveData(
                doc.data().cip,
                doc.data().nombre,
                doc.data().apellidos,
                doc.data().nivel,
                doc.id
              );
              setLoginDetails({ name: doc.data().nombre });
              //console.log("no habilitado " + doc.data().nivel);
              if (doc.data().nivel == "ingeniero") navigate("../panelUser");
            } else {
              console.log("no habilitado");
              Swal.fire({
                position: "center",
                icon: "error",
                title: "USUARIO NO HABILITADO",
                showConfirmButton: false,
                timer: 1500,
              });
            }
            console.log(res.data[0]);
            setBooks(res.data);
          } else {
            console.log("NO HAY CONECCION AL SERVIDOR");
          }
        } catch (err) {
          setErrorMessages({ name: "pass", message: "Usuario incorrecto" });
          setpbVisible(false);

          console.log(err);
        }
      } else {
        console.log("contraseña incorrecta");
        setErrorMessages({
          name: "pass",
          message: "Contraseña incorrecta",
        });
        setpbVisible(false);
      }
    });
    if (fl == 0) {
      //console.log("Usuario no encontrado");
      setErrorMessages({ name: "pass", message: "Usuario incorrecto" });
      setpbVisible(true);
    }
  }

  const handleInputChange = (event) => {
    setLoginDetails({
      ...loginDetails,
      [event.target.name]: event.target.value,
    });
  };

  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <Alert variant="outlined" severity="error">
        {errorMessages.message}
      </Alert>
    );

  const forgotPass = () => {
    Swal.fire(
      "Olvidaste tu contraseña?",
      "La contraseña es tu número CIP, si no ingresa, envía un mensaje por whatsapp al 931475966 con tu nombre y tu DNI para resetear tu contraseña.",
      "question"
    );
  };
  const btnLogin = (e) => {
    setpbVisible(true);
    verificarCampos();

    //handleLogin(loginDetails);
    e.preventDefault();
  };
  const [books, setBooks] = useState([]);

  useEffect(() => {
    //console.log("A ver si entra aca");
    if (habilidad == "2") {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "USUARIO NO HABILITADO",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, [habilidad]);
  useEffect(() => {
    if (localStorage.getItem("idLocal") == "") {
      //console.log("NO ES USER");
      navigate("../login");
    } else {
      const nivelUsuario = localStorage.getItem("nivelUsuario");
      console.log("Nivel de usuario " + nivelUsuario);

      if (nivelUsuario == "admin") navigate("../panelAdmin");
      if (nivelUsuario == "cda") navigate("../panelCDA");
      if (nivelUsuario == "ingeniero") navigate("../panelUser");
    }
  }, []);
  return (
    <div className="login">
      <div className="login-root">
        <div className="login-padreIzquierda">
          <div className="login-hIzquierda">
            <img src={logo} className="login-logoLogin" />
            <h1 className="login-titulologin"> REGISTRO</h1>
            <h1 className="login-titulologin"> DE EVENTOS</h1>
          </div>
        </div>
        <div className="login-padreDerecha">
          <div className="login-hDerecha">
            <h1 className="login-title">Iniciar sesion</h1>
            <form action="/" className="login-form">
              <label className="login-label">DNI</label>
              <input
                type="text"
                name="dni"
                value={loginDetails.dni}
                onChange={handleInputChange}
                className="login-input login-input-email"
              />
              <label className="login-label">Primer Apellido</label>
              <input
                type="text"
                name="primerApellido"
                value={loginDetails.primerApellido}
                onChange={handleInputChange}
                className="login-input login-input-email"
              />
              <label className="login-label">Contraseña (Código CIP) </label>
              <input
                type="password"
                name="password"
                placeholder="*********"
                value={loginDetails.password}
                onChange={handleInputChange}
                className="login-input login-input-password"
              />
              {renderErrorMessage("pass")}

              <input
                type="submit"
                value="Ingresar"
                onClick={btnLogin}
                className="login-primary-button login-login-button"
              />
              {pbVisible ? (
                <LinearProgress color="success" style={{ marginBottom: 20 }} />
              ) : null}
              <a onClick={forgotPass}> Olvide mi contraseña</a>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
